// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1Imj2","colCheckbox":"styles_colCheckbox__2vU6b"};